import { type FC, type JSX, Suspense } from "react"

import { Loading } from "~/shared/ui/components/Loading"

/**
 * Оборачивает компонент в {@link react!Suspense Suspense}
 * @param fallbackFn функция, которая возвращает элемент, передаваемый свойству `fallback` компонента `Suspense`
 * @hoc
 * @category HOC
 */
export function withSuspense(
	fallbackFn: () => JSX.Element | null = () => <Loading loading />
) {
	return function <P = NonNullable<unknown>>(C: FC<P>) {
		function WithSuspense(props: P) {
			return (
				<Suspense fallback={fallbackFn()}>
					{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
					{/* @ts-expect-error */}
					<C {...props} />
				</Suspense>
			)
		}

		WithSuspense.displayName = "WithSuspense_" + (C.displayName ?? C.name)

		return WithSuspense
	}
}
